import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "hierarchical-select" }
const _hoisted_2 = { class: "selected-value" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_5 = {
  key: 0,
  class: "hierarchical-dropdown"
}
const _hoisted_6 = {
  key: 0,
  class: "search-box"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "tree-container" }
const _hoisted_9 = { class: "tree-node-content" }
const _hoisted_10 = { class: "node-label" }
const _hoisted_11 = {
  key: 0,
  class: "badge bg-secondary ms-2"
}
const _hoisted_12 = {
  key: 0,
  class: "clear-selection"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tree = _resolveComponent("q-tree")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-control hierarchical-select-trigger", { 'disabled': _ctx.disabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.selectedLabel)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.selectedLabel), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.placeholder), 1))
      ]),
      _createElementVNode("i", {
        class: _normalizeClass(["bi", _ctx.isOpen ? 'bi-chevron-up' : 'bi-chevron-down'])
      }, null, 2)
    ], 2),
    (_ctx.isOpen)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.searchable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  ref: "searchInput",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  type: "text",
                  class: "form-control form-control-sm",
                  placeholder: _ctx.searchPlaceholder,
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
                }, null, 40, _hoisted_7), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-search search-icon" }, null, -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_q_tree, {
              ref: "treeRef",
              nodes: _ctx.filteredNodes,
              "node-key": "id",
              selected: _ctx.internalSelected,
              "no-connectors": true,
              "onUpdate:selected": _ctx.handleSelect,
              filter: _ctx.searchQuery,
              "no-results-label": _ctx.noResultsLabel,
              "no-nodes-label": _ctx.noNodesLabel
            }, {
              "default-header": _withCtx((prop) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi node-icon", _ctx.getNodeIcon(prop.node)]),
                    style: _normalizeStyle({ color: _ctx.getNodeColor(prop.node) })
                  }, null, 6),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(prop.node.label), 1),
                  (prop.node.badge)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(prop.node.badge), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["nodes", "selected", "onUpdate:selected", "filter", "no-results-label", "no-nodes-label"]),
            (_ctx.allowNull)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-secondary w-100",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleClear && _ctx.handleClear(...args)))
                  }, [
                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-x-circle" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.clearLabel), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])), [
          [_directive_click_outside, _ctx.closeDropdown]
        ])
      : _createCommentVNode("", true)
  ]))
}